import CascoSearchApplicantStep from './steps/CascoSearchApplicantStep/CascoSearchApplicantStep';
import CascoPersonalInformationStep from './steps/CascoPersonalInformationStep';
import CascoAccidentInfoStep from './steps/CascoAccidentInfoStep/CascoAccidentInfoStep';
import CascoAttachmentsStep from './steps/CascoAttachmentsStep/CascoAttachmentsStep';
import CascoConclusionStep from './steps/CascoConclusionStep/CascoConclusionStep';
import CascoCompensationStep from './steps/CascoCompensationStep';

export default [
  {
    step: 1,
    n: 1,
    id: 'searchApplicant',
    label: 'claim.searchApplicant',
    claimForm: 'cascoClaim',
    iconName: 'search',
    icon: null,
    content: CascoSearchApplicantStep,
  },
  {
    step: 2,
    n: 2,
    id: 'personalData',
    label: 'claim.personalDataTitle',
    claimForm: 'cascoClaim',
    iconName: 'user',
    icon: null,
    content: CascoPersonalInformationStep,
  },
  {
    step: 3,
    n: 3,
    id: 'accidentInfo',
    label: 'claim.accInfoTitle',
    claimForm: 'cascoClaim',
    iconName: 'info',
    icon: null,
    content: CascoAccidentInfoStep,
  },
  {
    step: 4,
    n: 4,
    id: 'compensation',
    label: 'claim.compensationTitle',
    claimForm: 'cascoClaim',
    iconName: 'credit card',
    icon: null,
    content: CascoCompensationStep,
  },
  {
    step: 5,
    n: 5,
    id: 'attachmentsTitle',
    label: 'claim.attachmentsTitle',
    claimForm: 'cascoClaim',
    iconName: 'cloud upload',
    icon: null,
    content: CascoAttachmentsStep,
  },
  {
    step: 6,
    n: 6,
    id: 'conclusionTitle',
    label: 'claim.conclusionTitle',
    claimForm: 'cascoClaim',
    iconName: 'clipboard check',
    icon: null,
    content: CascoConclusionStep,
  },
];
